import { defineStore } from 'pinia';
import { ref } from 'vue';
import getRestaurant from '@menu/Utils/getRestaurant';

export const useTapForDetailsStore = defineStore('tapForDetails', () => {
  const isTapForDetailsVisible = ref<boolean>(
    (() => {
      if (!getRestaurant().isTapForDetailsEnabled) {
        return false;
      }

      try {
        return (
          localStorage.getItem('tapForDetailsLastUsedDate') !==
          new Date().toISOString().slice(0, 10)
        );
      } catch (e) {
        return false;
      }
    })(),
  );

  const hideTapForDetails = () => {
    isTapForDetailsVisible.value = false;

    try {
      localStorage.setItem(
        'tapForDetailsLastUsedDate',
        new Date().toISOString().slice(0, 10),
      );
    } catch (e) {
      //
    }
  };

  return {
    isTapForDetailsVisible,
    hideTapForDetails,
  };
});
